// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pzW1","content":"styles_content__2lNhY","tableWrap":"styles_tableWrap__3cfti"};